// Phase 9 R2 — Transaction history query (read-only).
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import type { Database } from '@/integrations/supabase/types';

export type InventoryTransaction =
  Database['public']['Tables']['inventory_transactions']['Row'] & {
    creator_name?: string | null;
  };

export function useInventoryItemTransactions(itemId: string | null) {
  const { activeShop } = useAuth();
  const shopId = activeShop?.id;

  return useQuery({
    queryKey: ['inventory-transactions', shopId, itemId] as const,
    enabled: !!shopId && !!itemId,
    queryFn: async (): Promise<InventoryTransaction[]> => {
      if (!shopId || !itemId) return [];
      const { data, error } = await supabase
        .from('inventory_transactions')
        .select('*')
        .eq('shop_id', shopId)
        .eq('inventory_item_id', itemId)
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as InventoryTransaction[];
    },
    staleTime: 15_000,
  });
}
